import clsx from "clsx";
import { FormattedMessage } from "react-intl";
import { Logo } from "@oai/platform/ui/Icon";

import { messages } from "@/localization/Shared.messages";

import type { ReactNode } from "react";

export default function AdsManagerBrand({
  className,
  label,
  textClassName,
}: {
  className?: string;
  label?: ReactNode;
  textClassName?: string;
}) {
  return (
    <div className={clsx("flex items-center gap-2", className)}>
      <Logo color="var(--gray-1000)" width="20px" height="20px" />
      <span
        className={clsx(
          "text-primary text-[18px] leading-[29px] font-semibold tracking-[-0.18px]",
          textClassName,
        )}
      >
        {label ?? <FormattedMessage {...messages.adsManagerBeta} />}
      </span>
    </div>
  );
}
